/**
 * Per-crew chat "last seen" state.
 *
 * Implementation moved to `useReadState` (cross-device sync via an encrypted
 * `kind-30078` event) while preserving the same instant localStorage fast-path
 * and the same public API (`{ lastSeen, markSeen }`). Re-exported here so
 * existing imports keep working unchanged.
 */
export { useCrewChatRead } from '@/hooks/useReadState';
